<template>
    <TemplateBuilder
        :rowProp="data.rowProp"
        :useForm="data.useForm"
        :fields="data.fields"
        :skeleton="isLoading"
    ></TemplateBuilder>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { initData, isLoading } from "./haz-discuss-pictogram.logic";

export default defineComponent({
    components: {
        //CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading, /*createField*/ };
    }
});
</script>
